import React from 'react'
import { Box, Typography } from '@mui/material'
import LotCard from './LotCard'
import formatMoney from '../utils/formatMoney'

const ListLotItemOffer = (props) => {
  const { lotInfo, areaId, auction, ...rest } = props
  const { lot, offer } = lotInfo

  return (
    <LotCard
      lot={lot}
      meta={
        <Box sx={{ alignItems: 'center', display: 'flex', gap: 0.5, mt: 0.5 }}>
          <Typography sx={{ fontSize: '0.7rem', fontWeight: 800, letterSpacing: 0.5, textTransform: 'uppercase' }}>
            Oferta:
          </Typography>
          <Typography sx={{ color: '#56AF31', fontSize: '0.85rem', fontWeight: 600 }}>
            {formatMoney(parseInt(offer.amount, 10))}
          </Typography>
        </Box>
      }
      {...rest}
    />
  )
}

export default ListLotItemOffer
